import { render, staticRenderFns } from "./StandQuestionColumn.vue?vue&type=template&id=7ddb3477&scoped=true&"
import script from "./StandQuestionColumn.vue?vue&type=script&lang=js&"
export * from "./StandQuestionColumn.vue?vue&type=script&lang=js&"
import style0 from "./StandQuestionColumn.vue?vue&type=style&index=0&id=7ddb3477&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddb3477",
  null
  
)

export default component.exports